export const Spacer = ({ height }: { height: number }) => {
  return <div style={{ height: `${height}px` }}></div>;
};
